import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import moment from "Helpers/MomentCompat";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

import Button from "Components/Admin/Buttons";

import * as S from "./styles";

// Pasta de RELATÓRIOS (A11 — D8/D26, 29/08/2026): o proponente cadastra
// (Pendente), o ADMIN modera aqui; o patrocinador Aportado só vê aprovados.
// Relatório editado pelo proponente volta a Pendente e reaparece para
// avaliação.
const UpdateProjectReports = ({ projectId, onModerated }) => {
  const { api } = UseServices();
  const { showNotification } = UseNotification();
  const { loading, setLoading } = UseGlobalLoading();

  const [reports, setReports] = useState([]);

  const getReports = () => {
    api
      .post("/project-reports/list", { project_id: projectId })
      .then((response) => setReports(response.data?.reports || []))
      .catch((error) => HTTPErrorCallback(error));
  };

  useEffect(() => {
    if (projectId) getReports();
    // eslint-disable-next-line
  }, [projectId]);

  const evaluateReport = async (report_id, approved) => {
    setLoading(true);

    try {
      await api.post("/project-reports/evaluate", { report_id, approved });

      setLoading(false);
      showNotification(
        "success",
        "Sucesso!",
        "Relatório avaliado com sucesso!",
      );
      getReports();
      // Avaliou: o badge da aba precisa cair na hora (05/09/2026).
      if (onModerated) onModerated();
    } catch (error) {
      setLoading(false);
      return HTTPErrorCallback(error);
    }
  };

  return (
    <S.Wrapper>
      {!reports.length ? <span>Nenhum relatório cadastrado.</span> : null}

      {reports.map((report) => (
        <S.Report key={report.id}>
          <S.ReportInfos>
            <h2>{report.name}</h2>
            {report.description ? <p>{report.description}</p> : null}
            <span>
              Enviado por {report.user?.full_name || "—"} em{" "}
              {moment(report.created_at).format("DD/MM/YYYY")}
            </span>
            <a href={report.file_src} target="_blank" rel="noreferrer">
              Abrir arquivo
            </a>
          </S.ReportInfos>

          <S.Status status={report.status}>{report.status}</S.Status>

          {report.status === "Pendente" ? (
            <S.Buttons>
              <Button
                variant="critical"
                type="button"
                text="Reprovar"
                onClick={() => evaluateReport(report.id, false)}
                disabled={loading}
              />
              <Button
                variant="success"
                type="button"
                text="Aprovar"
                onClick={() => evaluateReport(report.id, true)}
                disabled={loading}
              />
            </S.Buttons>
          ) : null}
        </S.Report>
      ))}
    </S.Wrapper>
  );
};

export default UpdateProjectReports;
